import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export interface GamesProps {
  image: string;
  name: string;
  externalLink?: string;
}
interface GameCarouselProps {
  games: GamesProps[];
}
const GameCarousel = (props: GameCarouselProps) => {
  const { games } = props;
  const [count, setCount] = useState<number>(8);

  useEffect(() => {
    const updateCount = () => {
      if (window.innerWidth >= 1024) {
        setCount(8);
      } else {
        setCount(4);
      }
    };
    updateCount();
    window.addEventListener("resize", updateCount);
    return () => {
      window.removeEventListener("resize", updateCount);
    };
  }, []);
  const slides = [];
  for (let i = 0; i < games.length; i += count) {
    slides.push(games.slice(i, i + count));
  }

  return (
    <div className="flex justify-center">
      <div>
        <Carousel
          showArrows={true}
          showThumbs={false}
          infiniteLoop={true}
          autoPlay={true}
          interval={13000}
          emulateTouch={true}
          renderArrowPrev={(onClickHandler, hasPrev, label) =>
            hasPrev && (
              <button
                type="button"
                onClick={onClickHandler}
                title={label}
                className="absolute left-0 z-10 p-3 text-white bg-black bg-opacity-50 rounded-full transform -translate-y-1/2 top-1/2"
              >
                &lt;
              </button>
            )
          }
          renderArrowNext={(onClickHandler, hasNext, label) =>
            hasNext && (
              <button
                type="button"
                onClick={onClickHandler}
                title={label}
                className="absolute right-0 z-10 p-3 text-white bg-black bg-opacity-50 rounded-full transform -translate-y-1/2 top-1/2"
              >
                &gt;
              </button>
            )
          }
        >
          {slides.map((slide, slideIndex) => (
            <div
              key={slideIndex}
              className="grid grid-cols-2 lg:grid-cols-4 gap-4 px-4 py-4"
            >
              {slide.map((offer, index) => (
                <div
                  onClick={() => window.open(offer.externalLink, "_blank")}
                  key={index}
                  className="p-2 lg:transition-transform duration-300 ease-in-out lg:transform hover:scale-105 cursor-pointer"
                >
                  <img
                    src={offer.image}
                    alt={offer.name}
                    className="mx-auto rounded-2xl object-cover h-[10rem] md:h-[12rem] lg:h-[15rem] w-full"
                  />
                </div>
              ))}
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default GameCarousel;
